// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2Sbkz","footer":"ModalInfo_footer__1f8MX"};